/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import EditableCard from 'modules/common/editableCard.component';
import { showToast } from 'modules/layout/layout.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import {
  getAuthDestinationServices,
  updateAuthDestinationServicesRenter
} from 'modules/authorizations/store/actions/destinationService.actions';

const DESTINATION_RENTER_SERVICE_ID = '1f0148df-2898-4d52-88f1-03f8ceafb74f';

const RenterDetailsCard = props => {
  const { authId, details, isReadOnly = false } = props;
  const [isLoading, setIsLoading] = useState(false);

  const renterService = useMemo(
    () => details?.services?.find(s => s.authorizationFileServiceTypeId === DESTINATION_RENTER_SERVICE_ID),
    [details?.services]
  );

  const isDestinationRenterActive = Boolean(renterService);

  const destinationRenterInfo = details?.destinationServices?.destinationRenterInfo || {};
  const renter = destinationRenterInfo?.renter || {};

  useEffect(() => {
    if (isDestinationRenterActive && !details?.destinationServices) {
      props.getAuthDestinationServices(authId);
    }
  }, [isDestinationRenterActive, details?.destinationServices, authId]);

  if (!isDestinationRenterActive) {
    return null;
  }

  const tabs = [{ header: 'Renter Details', order: 1, iconPath: ['fas', 'fa-truck-moving'] }];

  const summaries = [
    {
      header: 'Lease End Date',
      accessorKey: 'leaseEndDate',
      type: 'date',
      required: false,
      value: renter?.leaseEndDate ?? null,
      tab: 1
    },
    {
      header: 'Notice has been given',
      accessorKey: 'noticeHasBeenGiven',
      type: 'checkbox',
      required: false,
      value: renter?.noticeHasBeenGiven ?? false,
      tab: 1
    },
    {
      header: 'Has Lease Break Penalty',
      accessorKey: 'hasLeaseBreakPenalty',
      type: 'checkbox',
      required: false,
      value: renter?.hasLeaseBreakPenalty ?? false,
      tab: 1
    },
    {
      header: 'Penalty Amount',
      accessorKey: 'penaltyAmount',
      type: 'money',
      required: false,
      value: renter?.penaltyAmount ?? '',
      tab: 1,
      showWhen: () => Boolean(renter?.hasLeaseBreakPenalty),
      showWhenModal: ({ values }) => Boolean(values?.hasLeaseBreakPenalty)
    },
    {
      header: 'Rental Leave Date',
      accessorKey: 'rentalLeaveDate',
      type: 'date',
      required: false,
      value: renter?.rentalLeaveDate ?? null,
      tab: 1
    }
  ];

  const updateRenterDetails = async (tab, values) => {
    if (!renter.renterServiceId) {
      props.showToast('Renter details have not been initialized. Please initialize the destination renter service before updating renter details.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR,
      });
      return false;
    }

    setIsLoading(true);

    const payload = { ...destinationRenterInfo };
    payload.renter = { ...(payload.renter || {}) };
    payload.areaTourInfo = {
      ...(payload.areaTourInfo || {}),
      areaTourAgentId: payload.areaTourInfo?.areaTourAgentId ?? 0,
    };

    payload.renter.specialNeeds = payload.renter.specialNeeds ?? '';
    payload.renter.schoolRequestNote = payload.renter.schoolRequestNote ?? '';
    payload.renter.leaseEndDate = values.leaseEndDate ?? null;
    payload.renter.noticeHasBeenGiven = values.noticeHasBeenGiven ?? false;
    payload.renter.hasLeaseBreakPenalty = values.hasLeaseBreakPenalty ?? false;
    payload.renter.penaltyAmount =
      values.hasLeaseBreakPenalty && values.penaltyAmount !== '' && values.penaltyAmount != null
        ? Number(values.penaltyAmount)
        : null;
    payload.renter.rentalLeaveDate = values.rentalLeaveDate ?? null;

    const resp = await props.updateAuthDestinationServicesRenter(authId, payload);
    if (resp?.type?.endsWith('_FAILURE')) {
      props.showToast('Failed to update renter details, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    }

    await props.getAuthDestinationServices(authId);
    setIsLoading(false);
    return true;
  };

  return (
    <Grid item>
      <EditableCard tabs={tabs} summaries={summaries} numColumns={5} updateFields={updateRenterDetails} isLoading={isLoading} hideEdit={isReadOnly} />
    </Grid>
  );
};

export default compose(
  connect(null, {
    updateAuthDestinationServicesRenter,
    getAuthDestinationServices,
    showToast
  })
)(RenterDetailsCard);
